import React, { Component } from 'react';
import getConfig from 'next/config';
// import './why.scss';

const config = getConfig().publicRuntimeConfig;

const items = [
	{
		imgUrl: '/static/images/home/Monthlygiving.png',
		imgAlt: 'Monthly Giving',
		text:
			'Opt to give monthly for our missions or NGO programs and make an impact'
	},
	{
		imgUrl: '/static/images/home/GiveIndiaFundraisers.png',
		imgAlt: 'GiveIndia Fundraisers',
		text: 'Support crowdfunding campaigns with one-time donations'
	},
	{
		imgUrl: '/static/images/home/CorporatePhilanthropy.png',
		imgAlt: 'Corporate Philanthropy',
		text: 'CSR and employee giving through trusted NGOs'
	},
	{
		imgUrl: '/static/images/home/ChoiceofCauses.png',
		imgAlt: 'Choice of Causes',
		text: 'Pick from causes like education, children, livelihoods, etc'
	},
	{
		imgUrl: '/static/images/home/NetworkofVerifiedNGOs.png',
		imgAlt: 'Network of verified NGOs',
		text: 'Partnered with 2,000+ NGOs across the country'
	},
	{
		imgUrl: '/static/images/home/WorldwideGiving.png',
		imgAlt: 'Worldwide giving',
		text: 'Donations in all currencies with tax benefit for India, US and UK'
	}
];
export default class index extends Component {
	render() {
		return (
			<div className="homescreen-why-gi">
				<div className="hs-why-gi-left container">
					<h2>India's largest and most trusted giving platform</h2>
					<div className="hs-why-gi-left-line"></div>
					<div className="hs-why-gi-left-list">
						{items.map((item, idx) => {
							return (
								<div className="hs-why-gi-left-item" key={idx}>
									<img
										src={`${config.cdnUrl}${item.imgUrl}`}
										alt={item.imgAlt}
										className="hs-why-gi-left-item-image"
									/>
									<p>{item.text}</p>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}
